import { useCallback, useState } from 'react';
import { RecordingLinkButton } from 'recording-review-components-lib/media-player/variant-addons/RecordingLinkButton';
import { RecordingDeleteButton } from 'recording-review-components-lib/media-player/variant-addons/RecordingDeleteButton';
import DeleteRecordingPrompt from './DeleteRecordingPrompt';
import CallTranscript from './CallTranscript';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MediaActions = ({
  callMessage,
  engagementId,
  hasVoicemail,
  onDeleteRecording
}) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const handleOpenDeleteConfirmModal = useCallback(() => {
    setShowDeleteDialog(true);
  }, []);
  const handleCloseDeleteConfirmModal = useCallback(() => {
    setShowDeleteDialog(false);
  }, []);
  const handleDeleteRecording = useCallback(() => {
    onDeleteRecording(engagementId);
    handleCloseDeleteConfirmModal();
  }, [handleCloseDeleteConfirmModal, engagementId, onDeleteRecording]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(RecordingDeleteButton, {
      onClick: handleOpenDeleteConfirmModal
    }), /*#__PURE__*/_jsx(RecordingLinkButton, {
      recordingType: hasVoicemail ? 'voicemail' : 'default'
    }), /*#__PURE__*/_jsx(CallTranscript, {
      callMessage: callMessage
    }), showDeleteDialog ? /*#__PURE__*/_jsx(DeleteRecordingPrompt, {
      onConfirm: handleDeleteRecording,
      onReject: handleCloseDeleteConfirmModal,
      hasVoicemail: hasVoicemail
    }) : null]
  });
};